import { z } from 'zod';

/**
 * One schema file per feature, driving the resolver **and** the request shape.
 * The TypeScript type is derived with `z.infer`, never hand-written in parallel.
 */

/**
 * The reply in thread.
 *
 * An empty body is refused here rather than sent. The owning service answers
 * `422` on a blank message, and it has a reason to: the two acts are split, so
 * «close it without a word» is the state control and the message endpoint has no
 * reason to accept an empty message. Neither has this form.
 */
export const replyFormSchema = z.object({
  body: z.string().trim().min(1, 'اكتب ردّك قبل الإرسال.'),
});

export type ReplyFormValues = z.infer<typeof replyFormSchema>;

/**
 * The state control.
 *
 * Validated as a non-empty string rather than against a member list: the
 * vocabulary is a configuration value the console reads at runtime, so a
 * compiled set here would be exactly the defect the catalog names — and the
 * owning service refuses an unconfigured member with its own code, carrying the
 * live vocabulary back with it.
 */
export const stateFormSchema = z.object({
  caseState: z.string().min(1, 'اختر وضعاً للحالة.'),
});

export type StateFormValues = z.infer<typeof stateFormSchema>;
